/* jshint node:true */
'use strict';

var React = require('react');

/* Components */
var LeagueTable         = require('./LeagueTable.jsx');
var PlayerList          = require('./PlayerList.jsx');
var GameInformation     = require('./GameInformation.jsx');
var MatchHistory        = require('./MatchHistory.jsx');
var NewsList            = require('./NewsList.jsx');
var MatchStats          = require('./MatchStats.jsx');
var Penalties           = require('./Penalties.jsx');
var Conversation        = require('./Conversation.jsx');
var Commentary          = require('./Commentary.jsx');
var HorizontalTimeline  = require('./HorizontalTimeline.jsx');
var VerticalTimeline    = require('./VerticalTimeline.jsx');
var TeamStats           = require('./TeamStats.jsx');
var Advert              = require('../../common/Advert.jsx');
var AdReloaderMixin     = require('../../../mixins/AdReloaderMixin.js');

var TabSummary = React.createClass({

    displayName: 'TabSummary',

    mixins : [ AdReloaderMixin ],

    getInitialState : function(){
        return {
            adWrapSelector : '#reactContainer .react-ad'
        };
    },

    renderAdvert: function(){
        return (
            <article className="ad-300" key="mpuadvert">
                <div className="ad-center">
                    <Advert id='game.rhs.mpu' className="ad-slot-incontent ad-wrapper" slotType="incontent" />
                </div>
            </article>
        );
    },

    renderPlayersList: function(){
        var oStore          = this.props.store;
        var sState          = this.props.matchState || 'pre'; //pre,post,live
        var iWidth          = this.props.width;

        var aHomeTeam       = oStore.getPlayersList('home');
        var aAwayTeam       = oStore.getPlayersList('away');
        var oHomeTeam       = oStore.getHomeTeam();
        var oAwayTeam       = oStore.getAwayTeam();

        return (
            <PlayerList key="playerslist" homeTeam={aHomeTeam} awayTeam={aAwayTeam} matchState={sState} home={oHomeTeam} away={oAwayTeam} width={iWidth} />
        );
    },

    renderGameInformation: function(){
        var oStore          = this.props.store;
        var oGameInfo       = oStore.getGameInformation();
        return (
            <GameInformation key="gameinfo" capacity={oGameInfo.capacity} attendance={oGameInfo.attendance} datetime={oGameInfo.datetime} coverage={oGameInfo.coverage} venue={oGameInfo.venueName} address={oGameInfo.address}/>
        );
    },

    renderConversation: function(){
        return (
            <Conversation key="conversation" query={this.props.query} />
        );
    },

    renderTeamStats: function(){
        var oStore          = this.props.store;
        var aStatsSummary   = oStore.getStatSummary();
        return (
            <TeamStats key="teamstats" stats={aStatsSummary} />
        );
    },

    renderMatchStats: function(){
        var oStore          = this.props.store;
        if(!oStore.hasStats()){
            return;
        }
        var possession      = oStore.getStatPercent('possession');
        var territory       = oStore.getStatPercent('territory');
        var matchStats      = oStore.getMatchStats();
        var gameStripProps  = oStore.getGameStripDetails();
        var homeTeam  = oStore.getHomeTeam() || {};
        var awayTeam  = oStore.getAwayTeam() || {};

        return (
            <MatchStats key="matchstats" changeView={this.props.changeView} stats={matchStats} territory={territory} possession={possession} home={{ logo:gameStripProps.teams.home.logo, abbreviation: gameStripProps.teams.home.abbreviation, color: homeTeam.color}} away={{ logo:gameStripProps.teams.away.logo, abbreviation: gameStripProps.teams.away.abbreviation, color: awayTeam.color}}  />
        );
    },

    renderMatchCommentary: function(){
        var oStore          = this.props.store;
        var aCommentary     = oStore.getCommentary();
        return (
            <Commentary key="commentary" gameEvents={aCommentary} changeView={this.props.changeView} />
        );
    },

    buildColC: function(){
        var oStore          = this.props.store;
        var leagueName      = oStore.getLeagueName();
        var aLeagueTable    = oStore.getLeagueTable();
        var newsList        = oStore.getNewsList();

        var aColC = [];

        aColC.push(this.renderAdvert());

        aColC.push((
            <LeagueTable key="table" tableHref={this.props.tableHref} date="" name={leagueName} table={aLeagueTable} />
        ));

        aColC.push((
            <NewsList key="news" header={newsList.header} link={newsList.link} articles={newsList.articles} />
        ));

        return aColC;
    },

    render: function () {

        var sState      = this.props.matchState || 'pre'; //pre,post,live
        var oStore      = this.props.store;
        var iWidth      = jQuery(window).outerWidth() || this.props.width;
        var rSummary    = null;
        var iMaxWidth   = 1279;

        var aColA = [];
        var aColB = [];
        var aColC = [];

        //<div className="hidden-sm hidden-md hidden-lg">
        //	<div className="sub-module linkFeedItem">
        //		<ul>
        //			<li><a className="icon-font-before icon-listen02-solid-before" href="#">Listen</a></li>
        //			<li><a className="icon-font-before icon-watch-outline-before" href="#">Watch</a></li>
        //		</ul>
        //	</div>
        //</div>
        //<HorizontalTimeline />
        //<VerticalTimeline />
        //<Penalties />

        if(sState === 'post'){

            if(iWidth >= iMaxWidth){

                aColA.push(this.renderPlayersList());
                aColA.push(this.renderGameInformation());

                aColB.push(this.renderMatchCommentary());
                aColB.push(this.renderMatchStats());

                aColC = this.buildColC();

            }else if(iWidth >= 768){

                aColB.push(this.renderMatchCommentary());
                aColB.push(this.renderMatchStats());
                aColB.push(this.renderPlayersList());
                aColB.push(this.renderGameInformation());

                aColC = this.buildColC();

            }else{
                aColB.push(this.renderMatchCommentary());
                aColB.push(this.renderMatchStats());
                aColB.push(this.renderAdvert());
                aColB.push(this.renderGameInformation());
            }

            aColB.push(this.renderConversation());

            rSummary = (
                <div className="layout-cbc">
                    <section className="col-one">
                        {aColA}
                    </section>
                    <section className="col-two">
                        {aColB}
                    </section>
                    <section id="now-feed" className="col-three">
                        {aColC}
                    </section>
                </div>
            );

        }else if(sState === 'live'){

            if(iWidth >= iMaxWidth){

                aColA.push(this.renderPlayersList());
                aColA.push(this.renderGameInformation());

                aColB.push(this.renderMatchCommentary());
                aColB.push(this.renderMatchStats());

                aColC = this.buildColC();

            }else if(iWidth >= 768){

                aColB.push(this.renderMatchCommentary());
                aColB.push(this.renderMatchStats());
                aColB.push(this.renderPlayersList());
                aColB.push(this.renderGameInformation());

                aColC = this.buildColC();

            }else{
                aColB.push(this.renderMatchCommentary());
                aColB.push(this.renderMatchStats());
                aColB.push(this.renderAdvert());
                aColB.push(this.renderGameInformation());
            }

            aColB.push(this.renderConversation());

            rSummary = (
                <div className="layout-cbc">
                    <section className="col-one">
                        {aColA}
                    </section>
                    <section className="col-two">
                        {aColB}
                    </section>
                    <section id="now-feed" className="col-three">
                        {aColC}
                    </section>
                </div>
            );

        }else{

            var head2head       = oStore.getHead2Head();
            var recentForm      = oStore.getRecentForm();
            var gameStripProps  = oStore.getGameStripDetails();

            aColB.push(this.renderMatchCommentary());
            aColB.push((
                <MatchHistory key="headtohead" data={head2head} head2head={true} />
            ));

            if(iWidth >= iMaxWidth){

                aColA.push(this.renderPlayersList());
                aColA.push(this.renderTeamStats());
                aColA.push(this.renderGameInformation());

                aColB.push((
                    <MatchHistory team={gameStripProps.teams.home} key="homeform" data={recentForm.home} />
                ));
                aColB.push((
                    <MatchHistory team={gameStripProps.teams.away} key="awayform" data={recentForm.away} />
                ));

                aColC = this.buildColC();

            }else if(iWidth >= 768){

                aColB.push((
                    <MatchHistory team={gameStripProps.teams.home} key="homeform" data={recentForm.home} />
                ));
                aColB.push((
                    <MatchHistory team={gameStripProps.teams.away} key="awayform" data={recentForm.away} />
                ));

                aColB.push(this.renderPlayersList());
                aColB.push(this.renderTeamStats());
                aColB.push(this.renderGameInformation());

                aColC = this.buildColC();

            }else{
                aColB.push(this.renderTeamStats());
                aColB.push(this.renderAdvert());
                aColB.push(this.renderGameInformation());
            }

            aColB.push(this.renderConversation());

            rSummary = (
                <div className="layout-cbc">
                    <section className="col-one">
                        {aColA}
                    </section>
                    <section className="col-two">
                        {aColB}
                    </section>
                    <section id="now-feed" className="col-three">
                        {aColC}
                    </section>
                </div>
            );
        }
        return rSummary;
    }
});

module.exports = TabSummary;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/TabSummary.jsx
 **/